import React from 'react';

export const FindTheMatch = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none" stroke="currentColor">
    {/* Top Question card */}
    <rect x="10" y="5" width="60" height="20" rx="4" fill="#fff" strokeWidth="0" />
    <path d="M30 15h15 M50 15h8" stroke="#cbd5e1" strokeWidth="2" strokeLinecap="round" />
    <text x="15" y="19" fontSize="12" fill="#facc15" stroke="none">★</text>
    <text x="62" y="19" fontSize="12" fill="#94a3b8" stroke="none" fontWeight="bold">?</text>

    {/* Bottom answers */}
    <rect x="10" y="35" width="60" height="20" rx="4" fill="#fff" strokeWidth="0" />
    <circle cx="20" cy="45" r="5" fill="#0ea5e9" stroke="none" />
    <rect x="35" y="40" width="10" height="10" rx="1" fill="#0ea5e9" stroke="none" />
    <text x="60" y="49" fontSize="12" fill="#0ea5e9" stroke="none" textAnchor="middle">★</text>
  </svg>
);

export const GameShowQuiz = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    {/* Background lines */}
    <path d="M15 10h50 M15 20h30" stroke="#fff" strokeWidth="3" strokeLinecap="round" opacity="0.5" />
    <text x="70" y="20" fontSize="18" fill="#fff" fontWeight="bold">?</text>

    {/* Options grid */}
    <g transform="translate(10, 30)">
      <rect x="0" y="0" width="28" height="12" rx="2" fill="#fff" />
      <path d="M10 3l8 6 M18 3l-8 6" stroke="#ef4444" strokeWidth="1.5" />

      <rect x="32" y="0" width="28" height="12" rx="2" fill="#fff" />
      <path d="M42 3l8 6 M50 3l-8 6" stroke="#ef4444" strokeWidth="1.5" />

      <rect x="0" y="15" width="28" height="12" rx="2" fill="#fff" />
      <path d="M10 18l8 6 M18 18l-8 6" stroke="#ef4444" strokeWidth="1.5" />

      <rect x="32" y="15" width="28" height="12" rx="2" fill="#fde047" />
      <path d="M42 20l3 4l6 -6" stroke="#15803d" strokeWidth="2" fill="none" />
    </g>
  </svg>
);

export const FlipCards = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    {/* Back card stack effect */}
    <rect x="25" y="8" width="35" height="45" rx="2" fill="#fff" opacity="0.4" />
    <rect x="20" y="12" width="35" height="45" rx="2" fill="#fff" opacity="0.7" />
    {/* Main card */}
    <rect x="15" y="16" width="35" height="45" rx="2" fill="#fff" />
    {/* Star content */}
    <path d="M32.5 35l-5 3 2-6-5-4h6l2-6 2 6h6l-5 4 2 6z" fill="#fde047" />
    <path d="M22 50h20" stroke="#cbd5e1" strokeWidth="2" strokeLinecap="round" strokeDasharray="4 2" />
    <text x="45" y="52" fontSize="10" fill="#cbd5e1">?</text>
  </svg>
);

export const AirPlan = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    <rect x="10" y="10" width="25" height="40" rx="3" fill="none" stroke="#fff" strokeWidth="2" />
    <rect x="15" y="15" width="15" height="8" rx="1" fill="#0ea5e9" stroke="#fff" strokeWidth="1" />
    <rect x="15" y="26" width="15" height="8" rx="1" fill="#0ea5e9" stroke="#fff" strokeWidth="1" />
    <rect x="15" y="37" width="15" height="8" rx="1" fill="#0ea5e9" stroke="#fff" strokeWidth="1" />

    <rect x="45" y="10" width="25" height="40" rx="3" fill="none" stroke="#fff" strokeWidth="2" />
    <rect x="50" y="15" width="15" height="8" rx="1" fill="#fde047" stroke="#fff" strokeWidth="1" />
    <rect x="50" y="26" width="15" height="8" rx="1" fill="#fde047" stroke="#fff" strokeWidth="1" />
    <rect x="50" y="37" width="15" height="8" rx="1" fill="#fde047" stroke="#fff" strokeWidth="1" />
  </svg>
);

export const MatchUp = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    <rect x="15" y="10" width="20" height="40" rx="3" fill="none" stroke="#fff" strokeWidth="2" />
    <rect x="20" y="15" width="10" height="10" rx="1" stroke="#fff" strokeWidth="1" strokeDasharray="2 2" />
    <rect x="20" y="35" width="10" height="10" rx="1" stroke="#fff" strokeWidth="1" strokeDasharray="2 2" />

    <rect x="45" y="10" width="25" height="12" rx="2" fill="#fde047" />
    <rect x="45" y="25" width="25" height="25" rx="2" fill="#fff" />
    <path d="M50 32h15 M50 38h15 M50 44h10" stroke="#cbd5e1" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const SentenceOrder = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    {/* Arrow indicating rearrangement */}
    <path d="M20 45 Q 40 35 60 45" stroke="#fca5a5" strokeWidth="2" fill="none" markerEnd="url(#arrowhead)" />

    <g transform="translate(5, 20)">
      <rect x="0" y="0" width="20" height="16" rx="2" fill="#fff" />
      <text x="10" y="11" fontSize="8" textAnchor="middle" fill="#334155" fontFamily="Sarabun">ฉัน</text>

      <rect x="22" y="0" width="30" height="16" rx="2" fill="#fff" />
      <text x="37" y="11" fontSize="8" textAnchor="middle" fill="#334155" fontFamily="Sarabun">โรงเรียน</text>

      <rect x="54" y="0" width="16" height="16" rx="2" fill="#fff" />
      <text x="62" y="11" fontSize="8" textAnchor="middle" fill="#334155" fontFamily="Sarabun">ไป</text>
    </g>
  </svg>
);

export const Anagram = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    <g transform="translate(10, 25)">
      <rect x="0" y="0" width="12" height="12" rx="2" fill="#fde047" />
      <text x="6" y="9" fontSize="9" textAnchor="middle" fill="#334155" fontFamily="Sarabun">ดิ</text>

      <rect x="14" y="0" width="12" height="12" rx="2" fill="#fff" />
      <text x="20" y="9" fontSize="9" textAnchor="middle" fill="#334155" fontFamily="Sarabun">ส</text>

      <rect x="28" y="0" width="12" height="12" rx="2" fill="#fde047" />
      <text x="34" y="9" fontSize="9" textAnchor="middle" fill="#334155" fontFamily="Sarabun">อ</text>

      <rect x="42" y="0" width="12" height="12" rx="2" fill="#fff" />
      <text x="48" y="9" fontSize="9" textAnchor="middle" fill="#334155" fontFamily="Sarabun">น</text>
    </g>
    <path d="M15 45 Q 35 55 55 45" stroke="#fca5a5" strokeWidth="2" fill="none" />
    <path d="M52 42l4 3l-3 3" fill="#fca5a5" stroke="none" />
  </svg>
);

export const CompleteSentence = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    {/* Draggable words */}
    <rect x="10" y="10" width="25" height="14" rx="3" fill="#fde047" />
    <text x="22.5" y="20" fontSize="8" textAnchor="middle" fill="#334155" fontFamily="Sarabun">ขับ</text>

    <rect x="40" y="10" width="25" height="14" rx="3" fill="#cbd5e1" />
    <text x="52.5" y="20" fontSize="8" textAnchor="middle" fill="#334155" fontFamily="Sarabun">หลับ</text>

    {/* Sentence frame */}
    <text x="15" y="45" fontSize="10" fill="#fff" fontFamily="Sarabun">พ่อ</text>
    <rect x="30" y="35" width="25" height="14" rx="2" fill="#fff" />
    <rect x="32" y="37" width="21" height="10" rx="1" fill="none" stroke="#cbd5e1" strokeWidth="1" strokeDasharray="2 2" />
    <text x="60" y="45" fontSize="10" fill="#fff" fontFamily="Sarabun">รถ</text>

    {/* Arrow */}
    <path d="M22 25 Q 25 35 30 38" stroke="#fca5a5" strokeWidth="1.5" fill="none" />
    <path d="M29 36l2 2l-2 2" stroke="#fca5a5" strokeWidth="1.5" />
  </svg>
);

export const Situation = () => (
  <svg viewBox="0 0 80 60" className="h-16 w-16" fill="none">
    <rect x="15" y="10" width="50" height="40" rx="2" fill="none" stroke="#fff" strokeWidth="2" />
    <rect x="20" y="15" width="40" height="30" rx="1" fill="none" stroke="#fff" strokeWidth="1" strokeDasharray="2 2" />

    <circle cx="40" cy="30" r="12" fill="#fff" />
    <path d="M40 38v2 M40 22v10" stroke="#0ea5e9" strokeWidth="3" strokeLinecap="round" />

    {/* Chat bubble tail */}
    <path d="M35 40l5 5 5-5" fill="#fff" />
  </svg>
);

export const IconImage = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
  </svg>
);

export const IconAudio = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
  </svg>
);

export const IconTrash = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </svg>
);

export const IconTarget = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" />
    <line x1="22" x2="18" y1="12" y2="12" />
    <line x1="6" x2="2" y1="12" y2="12" />
    <line x1="12" x2="12" y1="6" y2="2" />
    <line x1="12" x2="12" y1="22" y2="18" />
  </svg>
);

export const IconCheck = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const IconX = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export const IconInfo = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);

export const IconChevronUp = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="m18 15-6-6-6 6" />
  </svg>
);

export const IconChevronDown = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const IconPlus = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
